import { atom } from 'jotai';
import { Article } from 'shared/models/legacy';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleRelatedPost {
  searchId: string;
  items: Article[];
  cursor: number;
  hasMore: boolean;
}

type TArticleRelatedPostStore = { [key: string]: Promise<IArticleRelatedPost> | IArticleRelatedPost | undefined };

const $ArticleRelatedPostStore = atom<TArticleRelatedPostStore>({});

export const $ArticleRelatedPost = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleRelatedPostStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: IArticleRelatedPost | Promise<IArticleRelatedPost>) => {
      const old = get($ArticleRelatedPostStore);
      set($ArticleRelatedPostStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleRelatedPost+${encodeURIComponent(groupId)}`;

  return a;
});
